// SpotBidding 画面のタブ定義。
//
// 並びは spec `spot-bidding.md` 冒頭のタブ構成 (通常入札 / ブロック入札 / 約定結果 / オペレーション履歴)。
// 旧「通常入札履歴」「ブロック入札履歴」タブは無い (AC-BSP-038。 オペレーション履歴タブに統合)。
//
// design HTML `design/bidding/spot.html:654-660` 準拠:
//   - トランシェ構成 タブは設定アイコン (⚙) 付き
//   - トランシェ構成 と ブロック入札 の間に縦線 divider (= 業務 group 分離)

export type SpotTabKey =
  | 'normalBid'
  | 'tranche'
  | 'blockBid'
  | 'executionResult'
  | 'operationHistory'

export type SpotTabDef = {
  key: SpotTabKey
  labelKey: string // i18n key (page:biddingSpot.tab.*)
  phase: 1 | 2
  /** trailing divider をこのタブの右に挿入する (= 業務 group 境界)。 */
  trailingDivider?: boolean
  /** タブ label の左に表示する icon (= 'gear' for トランシェ構成)。 */
  icon?: 'gear'
  /** disabled tab に出す tooltip 文言 i18n key (= phase 2 共通でない理由を出すため)。 */
  tooltipKey?: string
}

export const SPOT_TABS: SpotTabDef[] = [
  { key: 'normalBid', labelKey: 'page:biddingSpot.tab.normalBid', phase: 1 },
  // トランシェ構成 タブ: P3 で対応 (トランシェ機能未確定のため一旦非表示)
  // {
  //   key: 'tranche',
  //   labelKey: 'page:biddingSpot.tab.tranche',
  //   phase: 2,
  //   icon: 'gear',
  //   trailingDivider: true,
  // },
  // ブロック入札 タブは frontend 実装済み (= BlockBidTab、 mock seed)。 phase 1 で有効化する。
  { key: 'blockBid', labelKey: 'page:biddingSpot.tab.blockBid', phase: 1 },
  {
    key: 'executionResult',
    labelKey: 'page:biddingSpot.tab.executionResult',
    phase: 1,
  },
  {
    key: 'operationHistory',
    labelKey: 'page:biddingSpot.tab.operationHistory',
    phase: 1,
  },
]

export const DEFAULT_SPOT_TAB: SpotTabKey = 'normalBid'

/**
 * 清算画面の「詳細」 (`jepx-settlement.md` AC-JST-009) で開くタブ。 通常入札・ブロック入札とも、
 * 約定結果は約定結果タブ (AC-BSP-037) で確認する。
 */
export const SETTLEMENT_DETAIL_LANDING_TAB: SpotTabKey = 'executionResult'
